// extracted by mini-css-extract-plugin
export default {"badge":"MapBrandBadge_badge__AqwsR","brand":"MapBrandBadge_brand__8S6V1","logo":"MapBrandBadge_logo__9KJMU","count":"MapBrandBadge_count__c0hkg"};